import styled, { css, themeGet, space } from '@styled'
import Anchor from '@ui/anchor'
import { boxImageAnimationSignal } from '@assets/css/animations'

export const BoxLargeImgInner = styled.div`
  background: #fff;
  border-radius: ${themeGet('radii.md')};
  overflow: hidden;
  position: relative;
  height: 100%;
`

export const BoxLargeImgMedia = styled.div`
  position: relative;
  .gatsby-image-wrapper,
  img {
    width: 100%;
  }
`

export const BoxLargeImgContent = styled.div`
  ${(props) =>
    props.$layout !== 2 &&
    css`
      padding-block-start: 32px;
      padding-block-end: 88px;
      padding-inline-start: 30px;
      padding-inline-end: 30px;
      text-align: center;
    `}
  ${(props) =>
    props.$layout === 2 &&
    css`
      padding-block-start: 25px;
      padding-block-end: 88px;
      padding-inline-start: 26px;
      padding-inline-end: 26px;
      text-align: start;
    `}
`

export const HeadingWrap = styled.h2`
  line-height: 1.25;
  ${(props) =>
    props.$layout !== 2 &&
    css`
      font-weight: 500;
      margin-block-end: 12px;
    `}
  ${(props) =>
    props.$layout === 2 &&
    css`
      font-weight: 600;
      margin-block-end: 2px;
      font-size: 18px;
    `}
`

export const CategoryWrap = styled.p`
  color: ${themeGet('colors.primary')};
  margin-block-end: 2px;
`

export const TextWrap = styled.p`
  color: ${themeGet('colors.primary')};
  ${(props) =>
    props.$layout === 2 &&
    css`
      margin-block-start: 13px;
      margin-block-end: 0;
    `}
`

export const BoxLargeImgBtnWrap = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 56px;
  line-height: 55px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  border-block-start: 1px solid ${themeGet('colors.gray.400')};
  a {
    color: ${themeGet('colors.secondary')};
  }
  &:before {
    background-color: ${themeGet('colors.secondary')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    transition: ${themeGet('transition')};
    z-index: -1;
  }
  .mt-btn {
  }
`

export const BoxLargeImgLink = styled(Anchor)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  text-indent: -99999px;
`

export const BoxCircleBtn = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 56px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  border-radius: ${themeGet('radii.round')};
  font-size: 24px;
  color: #fff;
  background: ${themeGet('colors.secondaryLight')};
  .icon {
    color: #fff;
  }
  &:hover {
    color: #fff;
  }
`

export const BoxCircleBtnWrap = styled.a`
  height: 56px;
  width: 56px;
  position: absolute;
  transform: ${(props) => `${props.transform || ''}`};
  left: 50%;
  bottom: 15px;
  .middle-dot {
    pointer-events: none;
    content: '';
    position: absolute;
    top: -12px;
    left: -12px;
    width: 80px;
    height: 80px;
    border-radius: ${themeGet('radii.round')};
    border: 2px solid ${themeGet('colors.secondary')};
    opacity: 0;
    transform-origin: 50% 50%;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    &.dot-2 {
      pointer-events: none;
      content: '';
      position: absolute;
      top: -12px;
      left: -12px;
      width: 80px;
      height: 80px;
      border-radius: ${themeGet('radii.round')};
      border: 2px solid ${themeGet('colors.secondary')};
      opacity: 0;
      transform-origin: 50% 50%;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
    }
  }
  &:hover {
    .middle-dot {
      animation: ${boxImageAnimationSignal} cubic-bezier(0, 0.55, 0.55, 1) 2s;
      animation-iteration-count: 1;
      animation-fill-mode: none;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
    }
    ${BoxCircleBtn} {
      background: ${themeGet('colors.secondary')};
    }
  }
`

export const BoxCircleBtnInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const BoxLargeImgWrap = styled.div`
  transition: ${themeGet('transition')};
  height: 100%;
  box-shadow: ${themeGet('shadows.default')};
  ${space};
  &:hover {
    transform: translateY(-5px);
    h5 {
      color: ${themeGet('colors.secondary')};
    }
    ${BoxLargeImgLink} {
      visibility: visible;
      opacity: 1;
    }
    ${BoxLargeImgBtnWrap} {
      &:before {
        transform: translateY(0);
      }
      a {
        color: #fff;
      }
    }
  }
`
